import React from 'react';
import { useLocation } from 'react-router-dom';
import { getLangFromPath } from '../i18n/lang';

import PrivacyPageUk from './static/PrivacyPage.uk.jsx';
import PrivacyPageEn from './static/PrivacyPage.en.jsx';
import PrivacyPageIt from './static/PrivacyPage.it.jsx';
import PrivacyPageFr from './static/PrivacyPage.fr.jsx';

export default function PrivacyPage() {
  const loc = useLocation();
  const lang = getLangFromPath(loc.pathname);
  const Map = { uk: PrivacyPageUk, en: PrivacyPageEn, it: PrivacyPageIt, fr: PrivacyPageFr };

  const L = Map[lang] || PrivacyPageUk;
  return <L />;
}
